
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-drawer-rate-calculator]';
  var INIT_FLAG = 'drawerRateCalculatorReady';

  /* The class the winning slot carries, and the class its Step block carries.
     Keep LIVE_CLASS in sync with the app embed's Mount selector. */
  var LIVE_CLASS = 'is-ddp-live';
  var HOST_CLASS = 'is-ddp-live-host';

  /* Prefill the ZIP on a later page load. The RATE is deliberately never
     persisted — it was priced against a cart that may no longer exist. */
  var REMEMBER_ZIP = true;
  var ZIP_KEY = 'lbShippingZip';

  /* Values survive a drawer re-render so the customer does not retype them. */
  var lastAddress = { country: '', province: '', zip: '' };

  /* And so does the answer, which the previous version threw away. */
  var lastRates = [];
  var lastSelected = null;          // { name, price, cents }

  /* The cart as it stood when those rates were priced. */
  var lastCart = null;              // { subtotal, count }

  /* The picker node itself, held across re-renders. A cart update detaches it
     with the markup it was sitting in; re-reading the DOM at that moment finds
     nothing, and a fresh copy would arrive without the app's listeners or the
     date the customer already picked. */
  var pickerNode = null;

  var refreshTimer = null;
  var requestSeq = 0;

  function el(root, name) {
    return root.querySelector('[data-drawer-rate-' + name + ']');
  }

  function all(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  /* -------------------------------------------------------------- money --- */

  function currency() {
    return (window.PXUTheme && window.PXUTheme.currency) || {};
  }

  function formatPrice(price) {
    var money = currency();
    var symbol = money.symbol || '$';
    var output = symbol + price;

    if (money.display_format === 'money_with_currency_format' && money.iso_code) {
      output = output + ' ' + money.iso_code;
    }

    return output;
  }

  /* The endpoint returns price as a decimal string in the shop currency
     ("39.03"). Cents are what the subtotal is in, so convert once, here. */
  function toCents(price) {
    var value = parseFloat(String(price).replace(/[^0-9.\-]/g, ''));

    if (isNaN(value)) {
      return null;
    }

    return Math.round(value * 100);
  }

  function formatCents(cents) {
    if (cents === null || isNaN(cents)) {
      return '';
    }

    var whole = (cents / 100).toFixed(2);
    var parts = whole.split('.');

    return formatPrice(parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
  }

  /* ------------------------------------------------------ zip remembering -- */

  function rememberZip(zip) {
    if (!REMEMBER_ZIP) {
      return;
    }

    try {
      window.sessionStorage.setItem(ZIP_KEY, zip || '');
    } catch (error) {
      /* Private mode, or storage blocked. In-memory only is fine. */
    }
  }

  function recallZip() {
    if (!REMEMBER_ZIP) {
      return '';
    }

    try {
      return window.sessionStorage.getItem(ZIP_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  /* --------------------------------------------------- country and state -- */

  function countryData(countryName) {
    if (!window.Countries) {
      return null;
    }
    return window.Countries[countryName] || null;
  }

  function readProvinces(countrySelect) {
    var option = countrySelect.options[countrySelect.selectedIndex];
    var raw;

    if (!option) {
      return [];
    }

    raw = option.getAttribute('data-provinces');

    if (!raw) {
      return [];
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function selectCountry(root, countrySelect) {
    var wanted = lastAddress.country || root.getAttribute('data-default-country') || '';
    var index;

    if (wanted) {
      for (index = 0; index < countrySelect.options.length; index += 1) {
        if (countrySelect.options[index].value === wanted) {
          countrySelect.selectedIndex = index;
          lastAddress.country = wanted;
          return;
        }
      }
    }

    if (countrySelect.options.length) {
      countrySelect.selectedIndex = 0;
      lastAddress.country = countrySelect.options[0].value;
    }
  }

  function buildProvinces(root, preselect) {
    var countrySelect = el(root, 'country');
    var provinceSelect = el(root, 'province');
    var provinceField = el(root, 'province-field');
    var provinceLabel = el(root, 'province-label');
    var zipInput = el(root, 'zip');
    var provinces = readProvinces(countrySelect);
    var data = countryData(countrySelect.value);
    var index;
    var option;

    provinceSelect.innerHTML = '';

    for (index = 0; index < provinces.length; index += 1) {
      option = document.createElement('option');
      option.value = provinces[index][0];
      option.textContent = provinces[index][1];
      provinceSelect.appendChild(option);
    }

    /* The field stays hidden. It is only revealed when the ZIP cannot be resolved. */
    provinceField.setAttribute('hidden', 'hidden');

    if (provinces.length && preselect) {
      provinceSelect.value = preselect;
    }

    lastAddress.province = provinces.length ? provinceSelect.value : '';

    if (data) {
      if (data.province_label && provinceLabel) {
        provinceLabel.textContent = data.province_label;
        provinceSelect.setAttribute('aria-label', data.province_label);
      }
      if (data.zip_label && zipInput) {
        zipInput.setAttribute('aria-label', data.zip_label);
        zipInput.setAttribute('placeholder', data.zip_label);
      }
    }
  }

  function normalise(value) {
    return String(value || '').toLowerCase().replace(/[^a-z]/g, '');
  }

  /*
   * country_option_tags gives province options whose value is the province name,
   * so a state code is matched against both the option value and its label.
   */
  function findProvinceOption(provinceSelect, code) {
    var lookup = window.LobsterBoysZipState;
    var name = lookup ? lookup.stateName(code) : '';
    var wantedCode = normalise(code);
    var wantedName = normalise(name);
    var option;
    var index;

    for (index = 0; index < provinceSelect.options.length; index += 1) {
      option = provinceSelect.options[index];

      if (normalise(option.value) === wantedCode || normalise(option.textContent) === wantedCode) {
        return option.value;
      }

      if (wantedName && (normalise(option.value) === wantedName || normalise(option.textContent) === wantedName)) {
        return option.value;
      }
    }

    return '';
  }

  function revealProvinceField(root) {
    el(root, 'province-field').removeAttribute('hidden');
  }

  /* ------------------------------------------------------------ painting -- */

  /* Every write below is guarded on an actual change. The drawer is watched by
     a MutationObserver that calls back into this file, so a write that changes
     nothing would still schedule another pass, and the two would chase each
     other for as long as the drawer is open. */

  function setHidden(node, shouldHide) {
    if (!node) {
      return;
    }
    if (shouldHide && !node.hasAttribute('hidden')) {
      node.setAttribute('hidden', 'hidden');
    } else if (!shouldHide && node.hasAttribute('hidden')) {
      node.removeAttribute('hidden');
    }
  }

  function setText(node, text) {
    if (node && node.textContent !== text) {
      node.textContent = text;
    }
  }

  function setClass(node, name, shouldHave) {
    if (!node) {
      return;
    }
    if (shouldHave && !node.classList.contains(name)) {
      node.classList.add(name);
    } else if (!shouldHave && node.classList.contains(name)) {
      node.classList.remove(name);
    }
  }

  function setState(root, state) {
    if (root.getAttribute('data-rate-state') !== state) {
      root.setAttribute('data-rate-state', state);
    }
  }

  function clearResponse(root) {
    var response = el(root, 'response');

    setHidden(response, true);
    response.classList.remove('drawer-rate-calculator__response--error');
    setText(el(root, 'message'), '');
    setHidden(el(root, 'message'), true);
    el(root, 'rates').innerHTML = '';
    setHidden(el(root, 'facts'), true);
  }

  function showMessage(root, text, isError) {
    var response = el(root, 'response');
    var message = el(root, 'message');

    setHidden(response, false);
    setText(message, text);
    setHidden(message, !text);

    if (isError) {
      response.classList.add('drawer-rate-calculator__response--error');
    } else {
      response.classList.remove('drawer-rate-calculator__response--error');
    }
  }

  var TRUCK =
    '<svg viewBox="0 0 28 22" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M1 3.6A1.6 1.6 0 0 1 2.6 2h12.2a1.6 1.6 0 0 1 1.6 1.6V16H1V3.6Z"/>' +
    '<path d="M16.4 7.2h4.4l3.9 4.2V16h-8.3V7.2Z"/>' +
    '<circle cx="7" cy="18.4" r="2.2"/><circle cx="20" cy="18.4" r="2.2"/></svg>';

  /* The destination line. The rate service returns null for description and
     delivery_date today, so the ZIP is the honest fallback; if the app starts
     sending either, it wins. */
  function rateMeta(rate) {
    if (rate.description) {
      return rate.description;
    }

    if (rate.delivery_date) {
      var when = new Date(rate.delivery_date + 'T12:00:00');
      if (!isNaN(when.getTime())) {
        return 'Arrives ' + when.toLocaleDateString(undefined, {
          weekday: 'long', month: 'short', day: 'numeric'
        });
      }
    }

    return 'Live lobster delivery to ' + lastAddress.zip;
  }

  /*
   * Rate options are buttons, not radio inputs. This markup sits inside
   * .ajax-cart__form and an input needs a `name` to group — which would then be
   * posted with every cart update.
   */
  function paintRates(root) {
    var list = el(root, 'rates');
    var facts = el(root, 'facts');
    var count = el(root, 'count');
    var single = lastRates.length === 1;
    var index;
    var rate;
    var item;
    var button;

    list.innerHTML = '';

    if (!lastRates.length) {
      setHidden(facts, true);
      return;
    }

    list.setAttribute('data-count', String(lastRates.length));

    for (index = 0; index < lastRates.length; index += 1) {
      rate = lastRates[index];
      item = document.createElement('li');
      item.className = 'drawer-rate-calculator__rate-item';

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'drawer-rate-calculator__rate';
      button.setAttribute('role', 'radio');
      button.setAttribute('data-rate-key', rate.key);
      button.setAttribute('aria-checked', lastSelected && lastSelected.key === rate.key ? 'true' : 'false');

      /* One rate is not a choice. It is announced, not offered. */
      if (single) {
        button.setAttribute('tabindex', '-1');
        button.setAttribute('aria-disabled', 'true');
      }

      button.innerHTML =
        '<span class="drawer-rate-calculator__rate-icon">' + TRUCK + '</span>' +
        '<span class="drawer-rate-calculator__rate-copy">' +
          '<span class="drawer-rate-calculator__rate-name"></span>' +
        '</span>' +
        '<span class="drawer-rate-calculator__rate-price money"></span>';

      button.querySelector('.drawer-rate-calculator__rate-name').textContent = rate.name;
      button.querySelector('.drawer-rate-calculator__rate-price').textContent = formatCents(rate.cents);

      item.appendChild(button);
      list.appendChild(item);
    }

    setText(count, single ? 'One rate available' : lastRates.length + ' rates available');
    setHidden(facts, false);
    setHidden(el(root, 'response'), false);
  }

  /* -------------------------------------------------------------- totals -- */

  function updateTotals() {
    all('[data-lbet]').forEach(function (block) {
      var subtotal = parseInt(block.getAttribute('data-lbet-subtotal'), 10);
      var shippingRow = block.querySelector('[data-lbet-shipping-row]');
      var shippingAmount = block.querySelector('[data-lbet-shipping-amount]');
      var totalNode = block.querySelector('[data-lbet-total]');
      var note = block.querySelector('[data-lbet-note]');
      var live = block.querySelector('[data-lbet-live]');
      var shipping = lastSelected ? lastSelected.cents : null;
      var next;

      if (isNaN(subtotal)) {
        return;
      }

      if (shipping === null) {
        /* No ZIP, no rate, or the ZIP was edited: the estimate is the subtotal
           and nothing else. Never a guess, never a placeholder. */
        setHidden(shippingRow, true);
        if (note) {
          setText(note, note.getAttribute('data-lbet-note-empty') || '');
        }
      } else {
        setHidden(shippingRow, false);
        setText(shippingAmount, formatCents(shipping));
        if (note) {
          setText(note, note.getAttribute('data-lbet-note-rated') || '');
        }
      }

      next = formatCents(subtotal + (shipping || 0));

      if (totalNode && totalNode.textContent.trim() !== next) {
        totalNode.textContent = next;
        setText(live, 'Estimated total ' + next);
      }
    });
  }

  function readCart() {
    var block = document.querySelector('[data-lbet]');

    if (!block) {
      return null;
    }

    return {
      subtotal: parseInt(block.getAttribute('data-lbet-subtotal'), 10),
      count: parseInt(block.getAttribute('data-lbet-item-count'), 10)
    };
  }

  /* --------------------------------------------------------- date picker -- */

  /*
   * The theme renders its cart drawer twice — once inside .mobile-header, once
   * for desktop — and the cart page adds a third slot of its own. Only one of
   * them is ever on screen, and which one depends on the viewport and on
   * whether the drawer is open. Taking the first match in document order picks
   * the mobile copy on desktop, which is display:none: the picker is mounted,
   * initialised, and invisible. That was the cart page bug.
   */

  function laidOut(node) {
    return Boolean(node) && node.getClientRects().length > 0;
  }

  /*
   * Whether a click at this slot's centre would actually land on it.
   *
   * getClientRects answers "does this occupy space", which is a different
   * question. A closed cart drawer is laid out and reports a rect while sitting
   * off-canvas, so it passes the first test and fails this one. The slot itself
   * is a zero-height container, so the Step block around it is what gets
   * hit-tested.
   */
  function reachable(node) {
    var box = node.closest('.lbstep') || node;
    var rect = box.getBoundingClientRect();
    var x;
    var y;
    var hit;

    if (!rect.width && !rect.height) {
      return false;
    }

    x = rect.left + rect.width / 2;
    y = rect.top + Math.min(rect.height / 2, 40);

    /* Off-screen — scrolled away, mid-animation, or parked off-canvas. Not
       answerable by hit test, and the caller has a fallback for exactly this. */
    if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) {
      return false;
    }

    hit = document.elementFromPoint(x, y);

    if (!hit) {
      return false;
    }

    /* The hit is usually a child — the step's heading. Containment either way
       counts as reaching it; anything else means something covers it. */
    return box.contains(hit) || hit.contains(box);
  }

  /*
   * Reachable wins. Read backwards, because when a theme renders its drawer
   * twice the copies share a z-index and the later one paints on top.
   * Then merely laid out, then the cart page's own slot, then the last slot so
   * the picker is already parked before a drawer opens rather than appearing a
   * frame late.
   */
  function chooseSlot() {
    var slots = all('[data-lb-date-slot]');
    var visible;
    var index;

    if (!slots.length) {
      return null;
    }

    visible = slots.filter(laidOut);

    for (index = visible.length - 1; index >= 0; index -= 1) {
      if (reachable(visible[index])) {
        return visible[index];
      }
    }

    if (visible.length) {
      return visible[visible.length - 1];
    }

    return document.querySelector('.cart__checkout-container [data-lb-date-slot]')
        || slots[slots.length - 1];
  }

  /*
   * The app owns .ddp--drawer. It is relocated into the Step 2 slot and
   * otherwise left alone: moved rather than cloned, because a clone would come
   * away without the listeners the app bound to it.
   */
  function adoptDatePicker() {
    var slot = chooseSlot();
    var steps = all('[data-lb-date-step]');
    var host = slot ? slot.closest('[data-lb-date-step]') : null;
    var picker;
    var index;

    /* Re-read only when the held node is really gone. A cart update detaches it
       along with the markup it sat in; the reference is still good, and it is
       the reference that carries the chosen date and the app's handlers. */
    if (!pickerNode || !pickerNode.parentNode) {
      picker = document.querySelector('.ddp--drawer') || document.querySelector('.ddp-embed .ddp');
      if (picker) {
        pickerNode = picker;
      }
    }

    picker = pickerNode;

    /* Exactly one slot carries the live class. Point the app embed's Mount
       selector at `.lbstep__date-slot.is-ddp-live` and it resolves to this same
       node, so neither script moves the picker back. */
    all('[data-lb-date-slot]').forEach(function (node) {
      setClass(node, LIVE_CLASS, node === slot);
    });

    for (index = 0; index < steps.length; index += 1) {
      setClass(steps[index], HOST_CLASS, steps[index] === host);
      /* A numbered header over an empty box is worse than no step at all, so
         only the step that actually holds the picker is shown. */
      setHidden(steps[index], !(picker && steps[index] === host));
    }

    if (!slot || !picker) {
      return;
    }

    /* The express-checkout gate borrows the picker into its own modal. Pulling
       it back mid-use would take the calendar out from under the buyer. */
    if (document.documentElement.hasAttribute('data-ddp-gate-open')) {
      return;
    }

    /* The guard that keeps the drawer responsive. This function runs from a
       MutationObserver on the drawer, and appending a node that is already in
       place still fires mutation records — so an unguarded append schedules its
       own next call, forever. */
    if (picker.parentElement !== slot) {
      slot.appendChild(picker);
    }
  }

  /* --------------------------------------------------------------- rates -- */

  /*
   * The endpoint answers with either {"errors": "message"} or a field map such
   * as {"province": ["Select a state"]}. Both shapes are surfaced as written,
   * with one exception: the state is derived from the ZIP, so a province
   * complaint means a ZIP this store could not place. Telling someone to
   * "select a state" when they were only ever shown one field is a dead end.
   */
  function errorText(payload) {
    var messages = [];
    var source;
    var key;

    if (!payload) {
      return 'We could not calculate shipping right now. Please try again.';
    }

    if (typeof payload === 'string') {
      return payload;
    }

    if (typeof payload.errors === 'string') {
      return payload.errors;
    }

    source = payload.errors && typeof payload.errors === 'object' ? payload.errors : payload;

    if (source.province && !source.zip) {
      return 'We could not find that ZIP code. Please double-check it.';
    }

    for (key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        messages.push([].concat(source[key]).join(', '));
      }
    }

    return messages.length ? messages.join('. ') : 'We could not calculate shipping right now. Please try again.';
  }

  function normaliseRates(list) {
    var out = [];
    var index;
    var rate;
    var cents;

    for (index = 0; index < (list || []).length; index += 1) {
      rate = list[index];
      cents = toCents(rate.price);

      if (cents !== null) {
        out.push({
          key: (rate.source || 'rate') + ':' + (rate.code || rate.name || index),
          name: rate.presentment_name || rate.name || 'Shipping',
          description: rate.description || '',
          delivery_date: rate.delivery_date || '',
          price: rate.price,
          cents: cents
        });
      }
    }

    return out;
  }

  function forgetRates() {
    lastRates = [];
    lastSelected = null;
  }

  function getRates(root, options) {
    var silent = Boolean(options && options.silent);
    var countrySelect = el(root, 'country');
    var provinceSelect = el(root, 'province');
    var provinceField = el(root, 'province-field');
    var zipInput = el(root, 'zip');
    var submit = el(root, 'submit');
    var cartUrl = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
    var lookup = window.LobsterBoysZipState;
    var digits = String(zipInput.value || '').replace(/[^0-9]/g, '');
    var province = '';
    var address;
    var query = [];
    var seq;
    var key;
    var code;

    if (digits.length < 5) {
      if (!silent) {
        forgetRates();
        showMessage(root, 'Please enter a 5 digit ZIP code.', true);
        setState(root, 'error');
        paintRates(root);
        updateTotals();
      }
      return;
    }

    if (provinceField.hasAttribute('hidden')) {
      code = lookup ? lookup.stateCode(digits) : '';
      province = code ? findProvinceOption(provinceSelect, code) : '';

      if (!province) {
        if (silent) {
          return;
        }
        forgetRates();
        revealProvinceField(root);
        showMessage(root, 'We could not match that ZIP code to a state. Please choose your state.', true);
        setState(root, 'error');
        paintRates(root);
        updateTotals();
        return;
      }

      provinceSelect.value = province;
    } else {
      province = provinceSelect.value;
    }

    address = {
      country: countrySelect.value,
      province: province,
      zip: zipInput.value
    };

    for (key in address) {
      if (Object.prototype.hasOwnProperty.call(address, key)) {
        query.push('shipping_address[' + encodeURIComponent(key) + ']=' + encodeURIComponent(address[key]));
      }
    }

    lastAddress.country = address.country;
    lastAddress.province = address.province;
    lastAddress.zip = address.zip;
    rememberZip(address.zip);

    seq = requestSeq += 1;

    setState(root, silent ? 'refreshing' : 'loading');

    if (!silent) {
      submit.setAttribute('disabled', 'disabled');
      clearResponse(root);
    }

    fetch(cartUrl + '/shipping_rates.json?' + query.join('&'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, payload: payload };
        });
      })
      .then(function (result) {
        if (seq !== requestSeq) {
          /* A newer request has already been sent; this answer is out of date. */
          return;
        }

        if (result.ok && result.payload && result.payload.shipping_rates) {
          var rates = normaliseRates(result.payload.shipping_rates);

          if (!rates.length) {
            /* A valid address the store simply does not serve — Hawaii answers
               200 with an empty list. Not an error, and not a blank box. */
            forgetRates();
            showMessage(root, 'No overnight service is available to ' + lastAddress.zip + '.', true);
            setState(root, 'idle');
          } else {
            var keep = lastSelected && rates.filter(function (rate) {
              return rate.key === lastSelected.key;
            })[0];

            lastRates = rates;
            lastSelected = keep || rates[0];
            lastCart = readCart();
            showMessage(root, '', false);
            setState(root, 'rated');
          }
        } else if (silent) {
          /* Keep the last good rate. See the header note. */
          setState(root, lastSelected ? 'rated' : 'idle');
        } else {
          forgetRates();
          showMessage(root, errorText(result.payload), true);
          setState(root, 'error');
        }

        paintRates(root);
        updateTotals();
      })
      .catch(function () {
        if (seq !== requestSeq) {
          return;
        }

        if (silent) {
          setState(root, lastSelected ? 'rated' : 'idle');
        } else {
          forgetRates();
          showMessage(root, 'We could not calculate shipping right now. Please try again.', true);
          setState(root, 'error');
          paintRates(root);
        }

        updateTotals();
      })
      .then(function () {
        if (!silent) {
          submit.removeAttribute('disabled');
        }
      });
  }

  /* ----------------------------------------------------------- re-pricing -- */

  /*
   * The drawer is re-rendered from Liquid whenever the cart changes, so the
   * subtotal and item count in the DOM are already correct. A difference
   * between them and the cart those rates were priced against is the signal —
   * no /cart.js poll, and no wrapping of window.fetch, which in a theme running
   * this many apps is a thing to avoid touching.
   */
  function repriceIfCartMoved() {
    var now = readCart();
    var root;

    if (!now || isNaN(now.subtotal)) {
      return;
    }

    if (!now.count) {
      /* Cart emptied. The rate belonged to an order that no longer exists. */
      forgetRates();
      lastCart = now;
      all(ROOT_SELECTOR).forEach(function (node) { clearResponse(node); });
      updateTotals();
      return;
    }

    if (!lastCart) {
      lastCart = now;
      return;
    }

    if (now.subtotal === lastCart.subtotal && now.count === lastCart.count) {
      return;
    }

    lastCart = now;

    if (!lastSelected) {
      return;
    }

    root = document.querySelector(ROOT_SELECTOR);

    if (!root) {
      return;
    }

    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      getRates(root, { silent: true });
    }, 450);
  }

  /* ---------------------------------------------------------------- init -- */

  function initRoot(root) {
    var countrySelect;
    var provinceSelect;
    var zipInput;

    if (!root || root[INIT_FLAG]) {
      return;
    }

    countrySelect = el(root, 'country');
    provinceSelect = el(root, 'province');
    zipInput = el(root, 'zip');

    /* Flagged only once the fields are actually present. Flagging first meant a
       root that rendered a frame ahead of its own children was marked done and
       never wired up. */
    if (!countrySelect || !provinceSelect || !zipInput) {
      return;
    }

    root[INIT_FLAG] = true;

    selectCountry(root, countrySelect);
    buildProvinces(root, lastAddress.province);

    if (!lastAddress.zip) {
      lastAddress.zip = recallZip();
    }

    if (lastAddress.zip) {
      zipInput.value = lastAddress.zip;
    }

    /* Repaint the answer the customer already had. This is the whole fix for
       "the rate disappears when I change a quantity". */
    if (lastRates.length) {
      paintRates(root);
    }

    countrySelect.addEventListener('change', function () {
      lastAddress.country = countrySelect.value;
      buildProvinces(root, '');
      forgetRates();
      clearResponse(root);
      setState(root, 'idle');
      updateTotals();
    });

    provinceSelect.addEventListener('change', function () {
      lastAddress.province = provinceSelect.value;
      forgetRates();
      clearResponse(root);
      setState(root, 'idle');
      updateTotals();
    });

    zipInput.addEventListener('input', function () {
      lastAddress.zip = zipInput.value;
      el(root, 'province-field').setAttribute('hidden', 'hidden');

      /* A rate on screen that was priced for a different ZIP is a lie the
         customer cannot see. Drop it the moment the field stops matching. */
      if (lastRates.length) {
        forgetRates();
        clearResponse(root);
        setState(root, 'idle');
        updateTotals();
      }
    });

    zipInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
        getRates(root);
      }
    });

    el(root, 'submit').addEventListener('click', function (event) {
      event.preventDefault();
      getRates(root);
    });

    el(root, 'rates').addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-rate-key]');
      var key;
      var index;

      if (!button || lastRates.length < 2) {
        return;
      }

      key = button.getAttribute('data-rate-key');

      for (index = 0; index < lastRates.length; index += 1) {
        if (lastRates[index].key === key) {
          lastSelected = lastRates[index];
        }
      }

      paintRates(root);
      updateTotals();
    });
  }

  function initAll() {
    all(ROOT_SELECTOR).forEach(initRoot);
    adoptDatePicker();
    updateTotals();
    repriceIfCartMoved();
  }

  /* ------------------------------------------------------------ watching -- */

  var passTimer = null;

  /* Everything above writes only on a real change, so a pass that finds nothing
     to do ends without producing a mutation of its own. That is what lets this
     observe broadly without feeding itself. */
  function schedulePass() {
    clearTimeout(passTimer);
    passTimer = setTimeout(initAll, 50);
  }

  function watchDrawers() {
    var drawers = document.querySelectorAll('.theme-ajax-cart');
    var observer;
    var index;

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    observer = new MutationObserver(schedulePass);

    for (index = 0; index < drawers.length; index += 1) {
      observer.observe(drawers[index], {
        childList: true,
        subtree: true,
        /* Most themes open a drawer by toggling an attribute rather than by
           inserting markup, so childList alone never learns it became visible —
           and which slot is reachable changes the moment it does. */
        attributes: true,
        attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style']
      });
    }

    /* The cart page's own Step block lives outside every drawer, and a static
       cart page produces no mutations at all. Watch its container too. */
    all('.cart__checkout-container').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
  }

  /* Crossing a breakpoint swaps which drawer is on screen without touching the
     DOM — it is a media query, and no observer fires for one. */
  function watchViewport() {
    var timer = null;

    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(initAll, 150);
    }

    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }

  function boot() {
    initAll();
    watchDrawers();
    watchViewport();

    /* Layout is not final the instant the DOM is ready, and the app embed
       injects its picker on its own schedule. A few settling passes stand in
       for the mutations a static page never produces; they stop after 2s and
       steady state is observer-driven from there. */
    [150, 600, 1500].forEach(function (delay) {
      setTimeout(initAll, delay);
    });

    window.addEventListener('load', initAll);
    window.addEventListener('pageshow', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('ddp:change', updateTotals);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* A small surface for the other scripts in this drawer. express-gate.js can
     listen for a priced shipment without reaching into the DOM. */
  window.LBShippingCalculator = {
    getRate: function () { return lastSelected; },
    getRates: function () { return lastRates.slice(); },
    getZip: function () { return lastAddress.zip; },
    refresh: function () {
      var root = document.querySelector(ROOT_SELECTOR);
      if (root) { getRates(root, { silent: true }); }
    }
  };
}());